import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { LoginDetails } from 'src/app/authentication/models/login-details.model';
import { showLocalFields } from 'src/app/common-components/utils/sso-helper';
import { AppConfigService } from 'src/app/app-config/app-config-service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-login-view',
    styleUrls: ['./login-view.component.scss'],
    templateUrl: './login-view.component.html',
    standalone: false
})
export class LoginViewComponent implements OnInit {
   @Input() appStartCallState: Observable<CallState>;

   @Input() isRelogin = false;

   @Input() loginCallState: Observable<CallState>;

   @Input() loginError: string | null;

   @Input() username = '';

   @Input() hasSaml2Authentication = false;

   @Output() loginClicked = new EventEmitter<LoginDetails>();

   @Output() cancelClicked = new EventEmitter();

   @Output() cannotSignInClicked = new EventEmitter();

   @Output() loginWithSSO = new EventEmitter();

   showLocalFields = false;

   samlSignInProgress = false;

   form: UntypedFormGroup;

   usernameControl: UntypedFormControl;

   passwordControl: UntypedFormControl;

   gitCommit: string | null = null;
   gitBranch: string | null = null;
   deployTimestamp: string | null = null;
   deployUser: string | null = null;
   enabledSkaffoldProfiles: string[] | null = null;
   releaseName: string | null = null;
   urlEnv: string | null = null;
   extraNames: string[] | null = null;

   constructor(private fb: UntypedFormBuilder, private appConfigService: AppConfigService) {}

   ngOnInit() {
      this.usernameControl = new UntypedFormControl();
      this.passwordControl = new UntypedFormControl();
      this.form = this.fb.group({
         password: ['', Validators.required],
         username: [{ disabled: this.isRelogin, value: this.username }, Validators.required],
      });
      this.showLocalFields = showLocalFields();

      // Load deployment metadata
      if (this.appConfigService.loaded) {
         this.loadDeployMetadata();
      }
   }

   private loadDeployMetadata(): void {
      const config = this.appConfigService.getConfig();
      this.gitCommit = config.gitCommit || null;
      this.gitBranch = config.gitBranch || null;
      this.deployTimestamp = config.deployTimestamp || null;
      this.deployUser = (config as any).deployUser || null;
      this.enabledSkaffoldProfiles = config.enabledSkaffoldProfiles || null;
      this.releaseName = (config as any).releaseName || null;
      this.urlEnv = (config as any).urlEnv || null;
      this.extraNames = (config as any).extraNames || null;
   }

   onContinueClick(): void {
      const formRawValue = this.form.getRawValue(); // get value regardless of disabled status
      this.loginClicked.emit({ password: formRawValue.password, username: formRawValue.username });
   }

   onSubmit() {
      const formRawValue = this.form.getRawValue(); // get value regardless of disabled status
      this.loginClicked.emit({ password: formRawValue.password, username: formRawValue.username });
   }

   onCancelClick(): void {
      this.cancelClicked.emit();
   }

   onCannotSignInClick(): void {
      this.cannotSignInClicked.emit();
   }

   onSSO() {
      this.loginWithSSO.emit();
      this.samlSignInProgress = true;
   }

   localSignIn() {
      this.showLocalFields = !this.showLocalFields;
   }

   ssoUserSignIn() {
      this.showLocalFields = !this.showLocalFields;
   }
}
